import { showLoginModal } from '../components/LoginModal.js';
import { getCurrentUser } from './authService';

type AuthAction = () => void | Promise<void>;

const pendingActionKey = 'gc_pending_auth_action';
const authActions = new Map<string, AuthAction>();

function readPendingActionId() {
  return window.sessionStorage.getItem(pendingActionKey);
}

export function registerAuthAction(actionId: string, action: AuthAction) {
  authActions.set(actionId, action);
}

export async function runWithAuth(actionId: string) {
  const action = authActions.get(actionId);
  if (!action) {
    throw new Error(`Auth action not registered: ${actionId}`);
  }

  if (getCurrentUser()) {
    await action();
    return true;
  }

  window.sessionStorage.setItem(pendingActionKey, actionId);
  showLoginModal();
  return false;
}

export async function resumePendingAuthAction() {
  const actionId = readPendingActionId();
  if (!actionId || !getCurrentUser()) {
    return false;
  }

  const action = authActions.get(actionId);
  window.sessionStorage.removeItem(pendingActionKey);

  if (!action) {
    return false;
  }

  await action();
  return true;
}

export function clearPendingAuthAction() {
  window.sessionStorage.removeItem(pendingActionKey);
}
